export default "__VITE_ASSET__p6elOwpM__"